import { QueryFunction, QueryKey, useQuery, UseQueryResult } from 'react-query';
import { PIPELINE_QUERY_OPTIONS } from './usePipelinesQueryConfig';

/** Shared `useQuery` wrapper that applies `PIPELINE_QUERY_OPTIONS`. */
export function usePipelineQuery<T>(
  key: QueryKey,
  fetcher: QueryFunction<T>
): UseQueryResult<T> {
  return useQuery<T>(key, fetcher, PIPELINE_QUERY_OPTIONS);
}
